

                
                            <div class="card-header header-background">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <p class="welcome-title" style="font-size: 25px;
                                        font-weight: bold;
                                        line-height: 25px;">Resultado Medición</p>
                                        <p class="welcome-title" style="font-size: 25px;
                                        font-weight: bold;
                                        line-height: 45px;">Satisfacción de Familias</p>
                                    </div>
                    
                                </div>
                            
                            </div>




                                    <div class="divTutoria">
                                        <div class="row">
                                            <div class="col-sm-12 divContainerData">
                                                <img src="../../../../../assets/icons/JUNJI__file_green.svg">
                                                <p (click)="verDocumentoJardin()" class="dataFecha docTitle">Certificado de medición de satisfacción de familias 2024</p>
                                            </div>
                                        </div>
                                    </div>
  

                      

                      
                      
